import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';

const ACTIVE_ARROW = '#9AD6D1';
const INACTIVE_ARROW = '#2E4A4F';

const defaultLabelStyles: SxProps<Theme> = {
  fontSize: '0.875rem',
  fontWeight: 700,
  lineHeight: 1,
  color: '#F6F8F9',
  letterSpacing: '0.02em',
};
type Props = {
  label: string;
  active: boolean;
  sortDirection: 'ASC' | 'DESC';
  onSort: () => void;
  labelStyles?: SxProps<Theme>;
};

const CustomTableSortLabel: FC<Props> = ({ label, active, sortDirection, onSort, labelStyles }) => {
  const upColor = active && sortDirection === 'ASC' ? ACTIVE_ARROW : INACTIVE_ARROW;
  const downColor = active && sortDirection === 'DESC' ? ACTIVE_ARROW : INACTIVE_ARROW;
  const styles = { ...defaultLabelStyles, ...labelStyles };
  return (
    <Box
      component="button"
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onSort();
      }}
      aria-label={
        active
          ? `${label}, sorted ${sortDirection === 'ASC' ? 'ascending' : 'descending'}. Click to reverse order.`
          : `${label}, activate to sort`
      }
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        maxWidth: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        color: 'inherit',
        textAlign: 'left',
        '&:focus-visible': {
          outline: '2px solid #9AD6D1',
          outlineOffset: 2,
          borderRadius: '2px',
        },
      }}
    >
      <Typography component="span" sx={styles}>
        {label}
      </Typography>
      <Box
        aria-hidden
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1px',
          flexShrink: 0,
          height: 13,
        }}
      >
        <Box
          sx={{
            width: 0,
            height: 0,
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            borderBottom: '5px solid',
            borderBottomColor: upColor,
          }}
        />
        <Box
          sx={{
            width: 0,
            height: 0,
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            borderTop: '5px solid',
            borderTopColor: downColor,
          }}
        />
      </Box>
    </Box>
  );
};

export default CustomTableSortLabel;
